import StatusChip from "components/shared/StatusChip";
import { agreementStatusRules } from "containers/ContractValidation";
import { formatLocaleDateString } from "helpers/utils";
import { t } from "i18next";
import { AgreementSignatureStatus } from "store/agreementsStore";
import type { IArticle } from "store/articleStore";

export const signedStatusRules = () => ({
    [AgreementSignatureStatus.TO_SIGN]: {
        color: "yellow",
        text: t("PressAudio.Management.ToSend"),
    },
    [AgreementSignatureStatus.SENT]: {
        color: "blue",
        text: t("PressAudio.Management.Pending"),
    },
    [AgreementSignatureStatus.SIGNED]: {
        color: "green",
        text: t("PressAudio.Management.Signed"),
    },
    [AgreementSignatureStatus.REFUSED]: {
        color: "red",
        text: t("PressAudio.Management.Refused"),
    },
});

interface IAgreementSignedStatus {
    value: AgreementSignatureStatus;
    article: IArticle;
    /**
     * uses_agreements_validation_chain company settings
     */
    usesAgreementValidation: boolean;
}
/**
 * Render Agreement signed status chip
 */
export const AgreementSignedStatus = ({ value, article, usesAgreementValidation }: IAgreementSignedStatus) => {
    const { lastSentAt, contractSignedDate, agreementStatus } = article;

    const isSigned = value === AgreementSignatureStatus.SIGNED;
    const isRefused = value === AgreementSignatureStatus.REFUSED;
    const hasAgreementStatus = usesAgreementValidation && !!agreementStatus && !isRefused;

    const sentOn = (() => {
        if (value === AgreementSignatureStatus.SENT && lastSentAt) {
            return t("PressAudio.Management.SentOn", {
                sentDate: formatLocaleDateString({ date: lastSentAt, options: { numeric: true, timeZone: "UTC" } }),
            });
        }
        return "";
    })();

    const _agreementStatus = isSigned ? "signed" : agreementStatus;

    const statusRules = hasAgreementStatus ? agreementStatusRules() : signedStatusRules();
    const extraText = isSigned
        ? formatLocaleDateString({ date: contractSignedDate, options: { numeric: true, timeZone: "UTC" } })
        : "";
    const status = hasAgreementStatus ? _agreementStatus : value;

    return <StatusChip statusRules={statusRules} status={status} extraText={extraText} tooltipText={sentOn} />;
};
